import React, { useEffect, useState, useRef, useCallback } from "react";
import styled, { css } from "styled-components";
import {
  C,
  SEMI,
  REG,
  Section,
  SegLabel,
  CardShell,
  CardHead,
  CardHeadTitle,
  ScrollBox,
  AccentStripe,
  ImportantTag,
  StatusTag,
  CheckSquare,
  CheckSquareIcon,
  fadeUp,
} from "../Styles";


export const TERMS = [
  {
    n: 1,
    t: "Payment - The full booking fee must be paid at the time of booking to confirm the reservation. Upon receipt of the payment, a representative from JustAct will contact the user/Applicant to confirm session details and request any additional documentation, if required.",
    h: false,
  },
  {
    n: 2,
    t: "Tribunal Secretary Fees - A facility for engaging a Tribunal Secretary is provided at the Centre. The fees in respect of Tribunal Secretary services shall be determined in accordance with the applicable fee schedule. The said fee schedule shall be communicated and made available to the parties as well as the Arbitrator at the Centre.",
    h: false,
  },
  {
    n: 3,
    t: "Arbitration Proceedings Expenses - All fees and expenses of the Arbitral Tribunal shall be borne by the parties. An invoice in respect of such fees and expenses shall be issued upon completion of each session before the Arbitral Tribunal.",
    h: false,
  },
  {
    n: 4,
    t: "Cancellation/Rescheduling Policy - (a) Cancellation or rescheduling made 0 to 7 days prior to the scheduled session – No refund. (b) Cancellation or rescheduling made within 8 to 15 days prior to the scheduled session – 50% refund. (c) Cancellation or rescheduling made more than 15 days prior to the scheduled session – Paid amount minus ₹2,500/- towards administrative charges.",
    h: false,
  },
  {
    n: 5,
    t: "Transcription - Transcription services with a turnaround time of 24 hours shall be provided on a complimentary basis, subject to availability.",
    h: false,
  },
  {
    n: 6,
    t: "Catering - Tea/Coffee and other refreshments shall be provided as a complimentary service, with one serving per participant for a half-day hearing and two servings per participant for a full-day hearing. Any additional servings shall be charged separately. Lunch may be arranged by the parties and shall be served only in the designated cafeteria area.",
    h: false,
  },
  {
    n: 8,
    t: "Session Recording - Recording sessions are available at ₹ 500 per hour. Parties must provide their own storage media to collect the recordings.",
    h: false,
  },
  {
    n: 9,
    t: "Weekend and Public Holiday Rates - Hearing room bookings scheduled on Saturdays, Sundays or public holidays declared by Tamil Nadu State Government shall be charged at the applicable higher weekend tariff, as displayed at the time of booking.",
    h: false,
  },
  {
    n: 10,
    t: "Participant Information - Accurate and complete details for all claimants, respondents, and arbitrators must be provided at the time of booking. NPAC and JustAct reserves the right to deny access to any individual whose identity cannot be verified.",
    h: false,
  },
  {
    n: 11,
    t: "Room Allocation - All room allocations, including the use of the Library Hall, shall be at the sole discretion of NPAC. The Library Hall may be assigned where required and NPAC reserves the right to reallocate any booking to an alternative hearing room based on availability and operational requirements. The Library Hall shall be an emergency allocation and is only made available when all regular hearing rooms are unavailable. Library Hall bookings may be reallocated to a regular room at NPAC's discretion upon payment of any additional fee.",
    h: false,
  },
  {
    n: 12,
    t: "Provisional Booking - All bookings submitted through this platform are provisional in nature. Confirmation shall be subject to verification of payment and session details by JustAct Operations.",
    h: false,
  },
  {
    n: 13,
    t: "Governing Law and Jurisdiction - These Terms and Conditions shall be governed by and construed in accordance with the laws of India, including the provisions of the Arbitration and Conciliation Act, 1996. Any disputes arising out of or in connection with these Terms shall be subject to the exclusive jurisdiction of the courts in Chennai, Tamil Nadu.",
    h: false,
  },
  {
    n: 14,
    t: "Damage to Property - Parties/Users shall be responsible for any damage caused to the Centre’s premises, equipment, or facilities during the session. The costs for repair or replacement shall be recoverable from the booking party, if not compensated by the party actually causing the damage.",
    h: false,
  },
  {
    n: 15,
    t: "Limitation of Liability - The Centre, including NPAC and JustAct, shall not be liable for any direct loss of property or indirect, incidental, or consequential loss, including loss of business, profits, or reputation arising out of or in connection with the use of its facilities or services.",
    h: false,
  },
  {
    n: 16,
    t: "Third-Party Services Disclaimer - Any third-party services (including transcription, stenography, catering, or technical support) are provided on an as-available basis. The Centre shall not be liable for deficiencies, delays, or errors attributable to such third-party service providers.",
    h: false,
  },
  {
    n: 17,
    t: "No Legal Advice - The Centre and its staff do not provide legal advice to any party. All administrative support is limited to procedural facilitation.",
    h: false,
  },
  {
    n: 18,
    t: "Force Majeure - The Centre shall not be liable for any failure or delay in performance due to events beyond its reasonable control, including but not limited to natural disasters, pandemics, power failures, government restrictions, or technical breakdowns.",
    h: false,
  },
  {
    n: 19,
    t: "Confidentiality of Proceedings - The Centre shall take reasonable steps to maintain confidentiality of arbitration proceedings; however, it shall not be responsible for any disclosure arising from acts of the parties, their representatives, or third-party service providers engaged for the session.",
    h: false,
  },
  {
    n: 20,
    t: "Amendment of Terms - The Centre reserves the right to amend these Terms and Conditions at any time. Updated Terms shall apply to all future bookings.",
    h: false,
  },
  {
    n: 21,
    t: "Entire Agreement - These Terms constitute the entire agreement between the parties with respect to the booking and use of the Centre’s facilities and supersede all prior communications or understandings.",
    h: false,
  },
];


const IMPORTANT_LABELS = {
  1: "Payment",
  3: "Settlement",
  6: "Cancellation Policy",
};

const StepTerms = ({ values, setFieldValue }) => {
  const accepted = values.termsAccepted;
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(
    Boolean(values.termsAccepted)
  );
  const scrollBoxRef = useRef(null);
  const hasScrolledRef = useRef(Boolean(values.termsAccepted));

  const checkBottom = useCallback((el) => {
    if (!el || hasScrolledRef.current) return;
    const isAtBottom =
      el.scrollHeight <= el.clientHeight + 10 ||
      el.scrollTop + el.clientHeight >= el.scrollHeight - 10;

    if (isAtBottom) {
      hasScrolledRef.current = true;
      setHasScrolledToBottom(true);
    }
  }, []);

  const handleScroll = (e) => {
    if (hasScrolledRef.current) return;
    checkBottom(e.currentTarget);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const el = scrollBoxRef.current;
    if (el) {
      if (!values.termsAccepted) {
        el.scrollTop = 0;
      }
      checkBottom(el);
    }

    const timer = setTimeout(() => {
      if (scrollBoxRef.current) {
        checkBottom(scrollBoxRef.current);
      }
    }, 150);

    return () => clearTimeout(timer); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); 

  const handleToggleAccept = () => {
    if (!hasScrolledToBottom) return;
    setFieldValue("termsAccepted", !accepted);
  };

  return (
    <>
      <Section $delay="0s">
        <SegLabel>Booking Terms</SegLabel>
        <CardShell>
          <CardHead>
            <CardHeadTitle>
              NPAC Room Booking — Terms &amp; Conditions
            </CardHeadTitle>
            <ClauseCount>{TERMS.length} clauses</ClauseCount>
          </CardHead>
          <ScrollBox ref={scrollBoxRef} onScroll={handleScroll}>
            {TERMS.map((t) => (
              <TermRow key={t.n} $h={t.h}>
                {t.h && <AccentStripe $navy />}
                <NumCol>
                  <NumBadge $h={t.h}>{t.n}</NumBadge>
                </NumCol>
                <TextCol>
                  <TermText $h={t.h}>{t.t}</TermText>
                  {t.h && IMPORTANT_LABELS[t.n] && (
                    <ImportantTag>{IMPORTANT_LABELS[t.n]}</ImportantTag>
                  )}
                </TextCol>
              </TermRow>
            ))}
          </ScrollBox>
        </CardShell>
      </Section>

      <Section $delay="0.08s" style={{ marginBottom: 0 }}>
        <ScrollInstruction $reached={hasScrolledToBottom}>
          <InstructionIcon $reached={hasScrolledToBottom}>
            {hasScrolledToBottom ? (
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            ) : (
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
              </svg>
            )}
          </InstructionIcon>
          <span>
            {hasScrolledToBottom
              ? "You've reached the end. You can now accept the terms."
              : "Please scroll to the bottom of the Terms & Conditions to enable acceptance."}
          </span>
        </ScrollInstruction>

        <AcceptShell
          $active={accepted}
          $disabled={!hasScrolledToBottom}
          onClick={handleToggleAccept}
          role="checkbox"
          aria-checked={accepted}
          aria-disabled={!hasScrolledToBottom}
          tabIndex={hasScrolledToBottom ? 0 : -1}
          onKeyDown={(e) => {
            if ((e.key === " " || e.key === "Enter") && hasScrolledToBottom) {
              e.preventDefault();
              handleToggleAccept();
            }
          }}
          title={
            !hasScrolledToBottom
              ? "Please scroll through all terms to enable acceptance"
              : undefined
          }
        >
          <CheckSquare $active={accepted}>
            {accepted && <CheckSquareIcon />}
          </CheckSquare>
          <AcceptBody>
            <AcceptTitle $active={accepted}>
              I have read and accept the Terms &amp; Conditions
            </AcceptTitle>
            <AcceptSub $active={accepted}>
              NPAC Room Booking — Nani Palkhivala Arbitration Centre
            </AcceptSub>
          </AcceptBody>
          <StatusTag $active={accepted}>
            {accepted ? "Accepted ✓" : "Pending"}
          </StatusTag>
        </AcceptShell>
      </Section>
    </>
  );
};

export default StepTerms;

/* ─── Styled components ──────────────────────────────────────────────────── */

const ClauseCount = styled.span`
  font-family: ${SEMI};
  font-size: 11px;
  font-weight: 600;
  color: ${C.muted};
  letter-spacing: 0.04em;
`;

const TermRow = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0;
  border-bottom: 1px solid ${(p) => (p.$h ? "transparent" : C.line)};
  position: relative;
  transition: background 0.15s;
  &:last-child {
    border-bottom: none;
  }
  ${(p) =>
    p.$h &&
    css`
      background: rgba(41, 52, 97, 0.035);
      border-bottom: 1px solid ${C.navyLine};
    `}
  &:hover {
    background: ${(p) => (p.$h ? "rgba(41,52,97,0.055)" : C.surface)};
  }
`;

const NumCol = styled.div`
  width: 52px;
  min-width: 52px;
  padding: 16px 0 16px 22px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
`;

const NumBadge = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${SEMI};
  font-weight: 700;
  font-size: 11px;
  flex-shrink: 0;
  transition: all 0.2s;
  ${(p) =>
    p.$h
      ? css`
          background: ${C.navy};
          color: ${C.white};
          box-shadow: 0 2px 8px rgba(41, 52, 97, 0.22);
        `
      : css`
          background: ${C.tealAlpha};
          color: ${C.teal};
          border: 1px solid ${C.tealLine};
        `}
`;

const TextCol = styled.div`
  flex: 1;
  padding: 16px 22px 16px 12px;
`;

const TermText = styled.p`
  font-family: ${(p) => (p.$h ? SEMI : REG)};
  font-weight: ${(p) => (p.$h ? 600 : 400)};
  font-size: 13px;
  color: ${(p) => (p.$h ? C.navy : C.textSub)};
  line-height: 1.68;
  margin: 0;
`;

const AcceptShell = styled.div`
  background: ${(p) => (p.$active ? C.navy : C.white)};
  border: 2px solid ${(p) => (p.$active ? C.teal : C.line)};
  border-radius: 16px;
  padding: 18px 22px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: ${(p) => (p.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(p) => (p.$disabled ? 0.55 : 1)};
  transition: all 0.25s ease;
  position: relative;
  overflow: hidden;
  animation: ${fadeUp} 0.38s ease 0.1s both;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${C.teal};
    opacity: ${(p) => (p.$active ? 1 : 0)};
    transition: opacity 0.22s;
  }
  ${(p) =>
    !p.$disabled &&
    css`
      &:hover {
        border-color: ${C.teal};
        background: ${p.$active ? C.navy : C.surface};
        box-shadow: 0 6px 24px
          ${p.$active ? "rgba(41,52,97,0.24)" : C.tealAlpha};
      }
    `}

  @media (max-width: 480px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

const AcceptBody = styled.div`
  flex: 1;
`;

const AcceptTitle = styled.div`
  font-family: ${SEMI};
  font-weight: 700;
  font-size: 14px;
  color: ${(p) => (p.$active ? C.white : C.text)};
  margin-bottom: 3px;
  letter-spacing: -0.01em;
  transition: color 0.22s;
`;

const AcceptSub = styled.div`
  font-family: ${REG};
  font-size: 12px;
  color: ${(p) => (p.$active ? "rgba(255,255,255,0.50)" : C.muted)};
  transition: color 0.22s;
`;

const ScrollInstruction = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 10px 14px;
  border-radius: 10px;
  margin-bottom: 12px;
  font-family: ${REG};
  font-size: 12.5px;
  line-height: 1.4;
  transition: all 0.25s ease;

  ${(p) =>
    p.$reached
      ? css`
          background: ${C.tealAlpha};
          border: 1px solid ${C.tealLine};
          color: ${C.tealDark};
        `
      : css`
          background: ${C.surface};
          border: 1px solid ${C.line};
          color: ${C.textSub};
        `}
`;

const InstructionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p) => (p.$reached ? C.teal : C.mutedMid)};
  transition: color 0.25s ease;
`;
